import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import ShieldWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithDollarSign';
import TwoMapPinsConnectedWithCurvyDottedLine from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoMapPinsConnectedWithCurvyDottedLine';
import Wallet from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Wallet';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { LinkStyled } from './styles';

export const ITEMS = [
  {
    id: 'fixed-variable-annuities-are-affordable',
    icon: Wallet,
    title: (<>They&#39;re more affordable than many <WidowBlock>people think.</WidowBlock></>),
    content:(
      <Typography
        align='left'
        disableBottomPadding>
        Like with all financial solutions, annuities do come with some costs. But there are also some big benefits. Depending on the type you choose, you can have tax deferment, a minimum death benefit, or guaranteed income for life.
      </Typography>
    ),
  },
  {
    id: 'fixed-variable-annuities-wont-lose-money',
    icon: ShieldWithDollarSign,
    title: (<>You won&#39;t lose your money if you pass away sooner <WidowBlock>than expected.</WidowBlock></>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Many fixed and variable annuities come with a death benefit. This feature makes sure your loved ones will get back at least what you put into your annuity if you pass away before your income payments start.
      </Typography>
    ),
  },
  {
    id: 'fixed-variable-annuities-is-it-affordable',
    icon: TwoMapPinsConnectedWithCurvyDottedLine,
    title: <>It&#39;s never too early or too late to start planning for <WidowBlock>the future.</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        With a fixed annuity, you can get guaranteed growth that&#39;s tax&#45;deferred.<sup>1</sup> With a variable annuity, you can invest your savings.<sup>2</sup> Either is a great option if you&#39;re rolling over a retirement plan or you&#39;ve maxed out your 401(k) or IRA contributions.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='fixed-variable-annuities'
      backgroundVariant='lightB'
      disableBottomPadding
      headingText={<>What to know about fixed and <WidowBlock>variable annuities:</WidowBlock></>}
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <Col align='center'>
            <LinkStyled
              id='fixed-variable-annuities-understanding-product-cta-fafa'
              variant='buttonLinkPrimary'
              themeType='lightTheme'
              linkUrl='/find-a-financial-advisor/'
              ariaLabel='Get your fixed variable annuities questions answered with a financial advisor'>
              Get started
            </LinkStyled>
          </Col>
        </Row>
      }
    />
  );
};
